/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type KiteDeployContractInfo = {
    ADDR: string;
    CNM: string;
    CMP: string;
    CMPVER: string;
    BL: string;
    TRXCNT: string;
    OPT: KiteDeployContractInfo.OPT;
    DPLUT: number;
};

export namespace KiteDeployContractInfo {

    export enum OPT {
        Y = 'Y',
        N = 'N',
    }


}

